import { Component, Input } from "@angular/core";
import { MachineMeasureUnit } from "app/models/enums.model";

@Component({
    selector: "app-measure-unit",
    templateUrl: "./measure-unit.component.html",
    styleUrls: ["./measure-unit.component.scss"],
    standalone: false
})
export class MeasureUnitComponent {
  @Input() measureUnit: MachineMeasureUnit;
  constructor() {}
}
